import React from "react";
import { View, Image } from "@react-pdf/renderer";
import { CommonStyles } from "../pdf-styles";

export const SVGRenderer = ({ svg, hasPropertyChanged }) => (
  <View fixed style={CommonStyles.svgContainer}>
    {svg && (
      <Image 
        cache={false}
        style={!!hasPropertyChanged ? { ...CommonStyles.svg, top: 10, left: 30 } : { ...CommonStyles.svg, top: -30, left: -10}}
        src={svg} 
      /> 
    )}
  </View>
);